import { MutationFunction, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { App } from 'antd';

import { queryClient } from '@/lib/react-query';
import { axiosClient } from '@/lib/axios';

type NotificationsParams = {
  companyID: number;
};

type NotificationsResponse = {
  message: string;
};

export const deleteAllNotification = async ({ companyID }: NotificationsParams): Promise<NotificationsResponse> => {
  const { data } = await axiosClient.delete<NotificationsResponse>(`/companies/${companyID}/notifications`);
  return data;
};

type UseDeleteNotificationOptions = {
  companyID: number;
  config?: MutationFunction<typeof deleteAllNotification>;
  postSuccess?: () => void;
};

export const useDeleteAllNotifications = ({ companyID, postSuccess, config }: UseDeleteNotificationOptions) => {
  const { notification: toaster } = App.useApp();
  return useMutation({
    onError: (error: AxiosError<{ message: string }>) => {
      toaster.error({
        message: 'Something Went Wrong',
        description: error.response?.data?.message,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['notifications'],
      });
      await queryClient.invalidateQueries({
        queryKey: ['company', companyID],
      });

      postSuccess?.();
    },
    ...config,
    mutationFn: deleteAllNotification,
  });
};
